// import { t } from "@lingui/macro";
// import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
// import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
// import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
// import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
// import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Chip,
//   CircularProgress,
//   Container,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   MenuItem,
//   Rating,
//   Stack,
//   Tab,
//   Tabs,
//   TextField,
//   Typography,
// } from "@mui/material";
// import { useEffect, useMemo, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import {
//   fetchLmsCourseChatMessages,
//   sendLmsCourseChatMessage,
//   fetchStudentLmsCourseFeedback,
//   fetchStudentLmsQuizResults,
//   fetchLmsQuizById,
//   submitLmsCourseFeedback,
//   submitLmsChapterQuiz,
//   submitLmsFinalQuiz,
//   useEnrollLmsCourse,
//   useLmsCourseDetails,
// } from "@/client/services/lms";
// import { useUser } from "@/client/services/user";

// const FINAL_QUIZ_CHAPTER_ID = "__final__";
// const DEFAULT_LMS_THUMBNAIL = "/LMS.png";
// const FEEDBACK_SUGGESTIONS = [
//   "Content quality",
//   "Instructor clarity",
//   "Quiz quality",
//   "Platform experience",
//   "Need more examples",
// ];

// const mapResourceDownloadUrl = (rawUrl: string) => {
//   const value = String(rawUrl || "").trim();
//   if (!value) return value;
//   if (value.startsWith("/exam/api/lms/resources/")) {
//     return value.replace("/exam/api/lms", "/api/integration/external-service/lms");
//   }
//   if (value.startsWith("/integration/external-service/lms/resources/")) {
//     return `/api${value}`;
//   }
//   return value;
// };

// type QuizResultView = {
//   label: string;
//   status: string;
//   answersMap: Record<string, number>;
// };

// const toQuizLabel = (percentage: unknown) => {
//   const parsed = Number(percentage);
//   return Number.isFinite(parsed) ? `${parsed}%` : "Completed";
// };
// const formatNameWithRole = (name: string, role?: string) => {
//   const safeName = String(name || "").trim();
//   const safeRole = String(role || "")
//     .trim()
//     .toLowerCase();
//   if (!safeName) return "";
//   if (!safeRole) return safeName;
//   if (safeName.includes("(") && safeName.includes(")")) return safeName;
//   return `${safeName}(${safeRole})`;
// };
// const extractRoleLabel = (roleValue: unknown) => {
//   if (!roleValue) return "";
//   if (typeof roleValue === "string") return roleValue.trim();
//   if (typeof roleValue === "object") {
//     const roleObject = roleValue as Record<string, unknown>;
//     const candidate =
//       roleObject.name || roleObject.role || roleObject.title || roleObject.label || roleObject.code;
//     return typeof candidate === "string" ? candidate.trim() : "";
//   }
//   return "";
// };

// const LmsCourseDetailsPage = () => {
//   const { courseId = "" } = useParams();
//   const navigate = useNavigate();
//   const { data: course, isLoading, refetch: refetchCourse } = useLmsCourseDetails(courseId);
//   const { user } = useUser();
//   const enrollMutation = useEnrollLmsCourse();
//   const [quizResultsByChapter, setQuizResultsByChapter] = useState<Record<string, QuizResultView>>(
//     {},
//   );
//   const [quizDialogOpen, setQuizDialogOpen] = useState(false);
//   const [activeQuizChapterId, setActiveQuizChapterId] = useState("");
//   const [activeQuiz, setActiveQuiz] = useState<any>(null);
//   const [resourcesDialogOpen, setResourcesDialogOpen] = useState(false);
//   const [activeResourcesChapterId, setActiveResourcesChapterId] = useState("");
//   const [activeResourcesTitle, setActiveResourcesTitle] = useState("");
//   const [activeResources, setActiveResources] = useState<
//     Array<{
//       id: string;
//       type: "url" | "text" | "file";
//       title?: string;
//       value: string;
//     }>
//   >([]);
//   const [quizAnswers, setQuizAnswers] = useState<Record<string, number>>({});
//   const [submittingQuiz, setSubmittingQuiz] = useState(false);
//   const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
//   const [feedbackRating, setFeedbackRating] = useState<number | null>(0);
//   const [feedbackText, setFeedbackText] = useState("");
//   const [feedbackSuggestions, setFeedbackSuggestions] = useState<string[]>([]);
//   const [feedbackSubmitting, setFeedbackSubmitting] = useState(false);
//   const [feedbackStatus, setFeedbackStatus] = useState<"submitted" | "skipped" | null>(null);
//   const [feedbackReadOnly, setFeedbackReadOnly] = useState(false);
//   const [activeTab, setActiveTab] = useState<"curriculum" | "chat">("curriculum");
//   const [chatMessages, setChatMessages] = useState<Array<any>>([]);
//   const [chatLoading, setChatLoading] = useState(false);
//   const [chatSubmitting, setChatSubmitting] = useState(false);
//   const [chatText, setChatText] = useState("");
//   const [isEnrolledLocal, setIsEnrolledLocal] = useState(false);
//   const [heroImageSrc, setHeroImageSrc] = useState(DEFAULT_LMS_THUMBNAIL);
//   const isEnrolled = Boolean(course?.enrolled || isEnrolledLocal);
//   const currentStudentIdentifiers = useMemo(
//     () =>
//       Array.from(
//         new Set(
//           [(user as any)?.rollNo, (user as any)?.studentId, user?.id, user?.email]
//             .map((value) =>
//               String(value || "")
//                 .trim()
//                 .toLowerCase(),
//             )
//             .filter(Boolean),
//         ),
//       ),
//     [user],
//   );
//   const currentStudentId = currentStudentIdentifiers[0] || "";
//   const currentStudentName = String(
//     (user as any)?.name ||
//       `${(user as any)?.first_name || ""} ${(user as any)?.last_name || ""}`.trim() ||
//       "",
//   ).trim();

//   const totalLessons = useMemo(
//     () =>
//       course?.chapters.reduce((accumulator, chapter) => accumulator + chapter.lessons.length, 0) ??
//       0,
//     [course?.chapters],
//   );
//   const completedLessonIds = useMemo(
//     () => new Set((course?.completedLessonIds || []).map((id) => String(id))),
//     [course?.completedLessonIds],
//   );
//   const chapterState = useMemo(() => {
//     const output: Record<string, { unlocked: boolean; completed: boolean; quizUnlocked: boolean }> =
//       {};
//     let allPreviousCompleted = true;
//     (course?.chapters || []).forEach((chapter, chapterIndex) => {
//       const lessonsCompleted = (chapter.lessons || []).every((lesson) =>
//         completedLessonIds.has(String(lesson.id)),
//       );
//       const quizRequired = Boolean(chapter.quizEnabled && chapter.quizId);
//       const quizCompleted =
//         String(quizResultsByChapter[chapter.id]?.status || "").toLowerCase() === "completed";
//       const completed = lessonsCompleted && (!quizRequired || quizCompleted);
//       const unlocked = chapterIndex === 0 ? true : allPreviousCompleted;
//       output[chapter.id] = {
//         unlocked,
//         completed,
//         quizUnlocked: unlocked && lessonsCompleted,
//       };
//       allPreviousCompleted = allPreviousCompleted && completed;
//     });
//     return output;
//   }, [completedLessonIds, course?.chapters, quizResultsByChapter]);

//   useEffect(() => {
//     const preferredHero = String(
//       course?.bannerUrl || course?.thumbnailUrl || DEFAULT_LMS_THUMBNAIL,
//     ).trim();
//     setHeroImageSrc(preferredHero || DEFAULT_LMS_THUMBNAIL);
//   }, [course?.bannerUrl, course?.thumbnailUrl]);

//   const allChaptersCompleted = useMemo(
//     () => Object.values(chapterState).every((chapter) => chapter.completed),
//     [chapterState],
//   );
//   const nextLessonByChapterId = useMemo(() => {
//     const map = new Map<string, string>();
//     const chapters = course?.chapters || [];
//     chapters.forEach((chapter, chapterIndex) => {
//       const nextChapter = chapters[chapterIndex + 1];
//       const nextLessonId = String(nextChapter?.lessons?.[0]?.id || "").trim();
//       if (nextLessonId) {
//         map.set(String(chapter.id), nextLessonId);
//       }
//     });
//     return map;
//   }, [course?.chapters]);

//   useEffect(() => {
//     const run = async () => {
//       if (!courseId || !user?.email || !user?.id) return;
//       try {
//         const rows = await fetchStudentLmsQuizResults(courseId);
//         const mapped: Record<string, QuizResultView> = {};
//         rows.forEach((row) => {
//           const rawAnswers = Array.isArray((row.rawResult as any)?.answers)
//             ? (row.rawResult as any).answers
//             : [];
//           const answersMap: Record<string, number> = {};
//           rawAnswers.forEach((answer: any) => {
//             const qid = String(answer?.questionId || "").trim();
//             if (!qid) return;
//             answersMap[qid] = Number(answer?.selectedOptionIndex ?? -1);
//           });
//           mapped[row.chapterId] = {
//             label: toQuizLabel(row.percentage),
//             status: String(row.status || ""),
//             answersMap,
//           };
//         });
//         setQuizResultsByChapter(mapped);
//       } catch {
//         setQuizResultsByChapter({});
//       }
//     };
//     run();
//   }, [courseId, user?.email, user?.id]);

//   useEffect(() => {
//     const run = async () => {
//       if (!courseId || !user?.id) return;
//       try {
//         const existing = await fetchStudentLmsCourseFeedback(courseId);
//         if (!existing) return;
//         const nextStatus = existing.status === "skipped" ? "skipped" : "submitted";
//         setFeedbackStatus(nextStatus);
//         setFeedbackRating(Number(existing.rating ?? 0));
//         setFeedbackText(String(existing.feedback || ""));
//         setFeedbackSuggestions(Array.isArray(existing.suggestions) ? existing.suggestions : []);
//       } catch {
//         // Ignore feedback fetch errors on page load.
//       }
//     };
//     run();
//   }, [courseId, user?.id]);

//   useEffect(() => {
//     if (!course?.id || !isEnrolled || activeTab !== "chat" || !currentStudentId) return;
//     let active = true;
//     const run = async () => {
//       try {
//         const rows = await fetchLmsCourseChatMessages(course.id, { limit: 120 });
//         if (active) setChatMessages(rows);
//       } catch {
//         if (active) setChatMessages([]);
//       } finally {
//         if (active) setChatLoading(false);
//       }
//     };

//     setChatLoading(true);
//     run();
//     const timer = window.setInterval(run, 8000);
//     return () => {
//       active = false;
//       window.clearInterval(timer);
//     };
//   }, [activeTab, isEnrolled, course?.id, currentStudentId]);

//   const openChapterQuiz = async (chapterId: string, quizId: string) => {
//     if (!quizId) return;
//     const quiz = await fetchLmsQuizById(quizId);
//     setActiveQuizChapterId(chapterId);
//     setActiveQuiz(quiz);
//     const savedAnswers = quizResultsByChapter[chapterId]?.answersMap || {};
//     setQuizAnswers(savedAnswers);
//     setQuizDialogOpen(true);
//   };

//   const openChapterResources = (chapterId: string) => {
//     const chapter = (course?.chapters || []).find((item) => String(item.id) === String(chapterId));
//     if (!chapter || !chapter.resourcesEnabled) return;
//     const resources = (chapter.resources || []).filter((item) => String(item.value || "").trim());
//     if (resources.length === 0) return;

//     setActiveResourcesChapterId(String(chapter.id));
//     setActiveResourcesTitle(String(chapter.resourcesTitle || chapter.title || "").trim());
//     setActiveResources(resources);
//     setResourcesDialogOpen(true);
//   };

//   const openFeedbackDialog = (readOnly = false) => {
//     setFeedbackReadOnly(readOnly);
//     setFeedbackDialogOpen(true);
//   };

//   const submitQuiz = async () => {
//     if (!course || !activeQuizChapterId || !activeQuiz) return;
//     if (
//       String(quizResultsByChapter[activeQuizChapterId]?.status || "").toLowerCase() === "completed"
//     ) {
//       setQuizDialogOpen(false);
//       return;
//     }
//     const answers = (activeQuiz.questions || []).map((question: any) => ({
//       questionId: question.id,
//       selectedOptionIndex: Number(quizAnswers[question.id] ?? -1),
//     }));
//     setSubmittingQuiz(true);
//     try {
//       if (activeQuizChapterId === FINAL_QUIZ_CHAPTER_ID) {
//         await submitLmsFinalQuiz({
//           courseId: course.id,
//           answers,
//         });
//       } else {
//         await submitLmsChapterQuiz({
//           courseId: course.id,
//           chapterId: activeQuizChapterId,
//           answers,
//         });
//       }
//       const rows = await fetchStudentLmsQuizResults(course.id);
//       const mapped: Record<string, QuizResultView> = {};
//       rows.forEach((row) => {
//         const rawAnswers = Array.isArray((row.rawResult as any)?.answers)
//           ? (row.rawResult as any).answers
//           : [];
//         const answersMap: Record<string, number> = {};
//         rawAnswers.forEach((answer: any) => {
//           const qid = String(answer?.questionId || "").trim();
//           if (!qid) return;
//           answersMap[qid] = Number(answer?.selectedOptionIndex ?? -1);
//         });
//         mapped[row.chapterId] = {
//           label: toQuizLabel(row.percentage),
//           status: String(row.status || ""),
//           answersMap,
//         };
//       });
//       setQuizResultsByChapter(mapped);
//       setQuizDialogOpen(false);
//       if (activeQuizChapterId === FINAL_QUIZ_CHAPTER_ID && !feedbackStatus) {
//         openFeedbackDialog(false);
//       }
//     } finally {
//       setSubmittingQuiz(false);
//     }
//   };

//   if (isLoading) {
//     return (
//       <Stack alignItems="center" py={8}>
//         <CircularProgress />
//       </Stack>
//     );
//   }

//   if (!course) {
//     return (
//       <Container>
//         <Typography>{t`Course not found.`}</Typography>
//       </Container>
//     );
//   }

//   const onEnroll = async () => {
//     await enrollMutation.mutateAsync({ courseId: course.id });
//     setIsEnrolledLocal(true);
//     await refetchCourse();
//   };
//   const downloadCertificate = () => {
//     const profile = user as any;
//     const identifiers = Array.from(
//       new Set(
//         [profile?.id, profile?.studentId, profile?.rollNo, profile?.email]
//           .map((value) => String(value || "").trim())
//           .filter(Boolean),
//       ),
//     );
//     const studentName = String(
//       profile?.name || `${profile?.first_name || ""} ${profile?.last_name || ""}`.trim() || "",
//     ).trim();
//     const params = new URLSearchParams();
//     if (identifiers[0]) params.set("studentId", identifiers[0]);
//     if (identifiers.length > 0) params.set("identifiers", identifiers.join(","));
//     if (studentName) params.set("studentName", studentName);
//     const url = `/api/integration/external-service/lms/courses/${course.id}/certificate?${params.toString()}`;
//     window.open(url, "_blank");
//   };
//   const activeQuizCompleted =
//     String(quizResultsByChapter[activeQuizChapterId]?.status || "").toLowerCase() === "completed";
//   const nextLessonIdForActiveQuizChapter = String(
//     nextLessonByChapterId.get(String(activeQuizChapterId)) || "",
//   ).trim();
//   const nextLessonIdForActiveResourcesChapter = String(
//     nextLessonByChapterId.get(String(activeResourcesChapterId)) || "",
//   ).trim();
//   const activeResourcesChapter = (course?.chapters || []).find(
//     (chapter) => String(chapter.id) === String(activeResourcesChapterId),
//   );
//   const hasQuizForActiveResourcesChapter = Boolean(
//     activeResourcesChapter?.quizEnabled && String(activeResourcesChapter?.quizId || "").trim(),
//   );
//   const hasStartedCourse = Number(course.progressPercent ?? 0) > 0 || completedLessonIds.size > 0;
//   const guestInstructorRows = (course.guestInstructors || [])
//     .map((name, index) => ({
//       name: String(name || "").trim(),
//       description: String(course.guestInstructorDescriptions?.[index] || "").trim(),
//     }))
//     .filter((row) => row.name);

//   const loadCourseChatMessages = async () => {
//     if (!course?.id || !isEnrolled || !currentStudentId) return;
//     setChatLoading(true);
//     try {
//       const rows = await fetchLmsCourseChatMessages(course.id, { limit: 120 });
//       setChatMessages(rows);
//     } catch {
//       setChatMessages([]);
//     } finally {
//       setChatLoading(false);
//     }
//   };

//   const submitChatMessage = async () => {
//     if (!course?.id || !isEnrolled) return;
//     const message = chatText.trim();
//     if (!message) return;
//     setChatSubmitting(true);
//     try {
//       await sendLmsCourseChatMessage({ courseId: course.id, message });
//       setChatText("");
//       await loadCourseChatMessages();
//     } finally {
//       setChatSubmitting(false);
//     }
//   };

//   const toggleFeedbackSuggestion = (value: string) => {
//     setFeedbackSuggestions((prev) =>
//       prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value],
//     );
//   };

//   const submitCourseFeedback = async () => {
//     if (!course) return;
//     if (feedbackStatus === "submitted") return;
//     const rating = Number(feedbackRating ?? 0);
//     if (rating < 1 || rating > 5) return;

//     setFeedbackSubmitting(true);
//     try {
//       await submitLmsCourseFeedback({
//         courseId: course.id,
//         status: "submitted",
//         rating,
//         feedback: feedbackText,
//         suggestions: feedbackSuggestions,
//       });
//       setFeedbackStatus("submitted");
//       setFeedbackReadOnly(true);
//       setFeedbackDialogOpen(false);
//     } finally {
//       setFeedbackSubmitting(false);
//     }
//   };

//   const skipCourseFeedback = async () => {
//     if (!course) return;
//     if (feedbackStatus === "submitted") {
//       setFeedbackDialogOpen(false);
//       return;
//     }
//     setFeedbackSubmitting(true);
//     try {
//       await submitLmsCourseFeedback({
//         courseId: course.id,
//         status: "skipped",
//         rating: 0,
//         feedback: "",
//         suggestions: [],
//       });
//       setFeedbackStatus("skipped");
//       setFeedbackDialogOpen(false);
//     } finally {
//       setFeedbackSubmitting(false);
//     }
//   };
//   const handleGoBack = () => {
//     if (window.history.length > 1) {
//       navigate(-1);
//       return;
//     }
//     navigate("/lms");
//   };

//   return (
//     <Box>
//       <Container>
//         <Stack spacing={2}>
//           <Box>
//             <Button
//               startIcon={<ArrowBackIcon />}
//               size="small"
//               onClick={handleGoBack}
//               sx={{ textTransform: "none" }}
//             >
//               {t`Back`}
//             </Button>
//           </Box>
//           <Box
//             component="img"
//             src={heroImageSrc}
//             alt={course.title}
//             onError={() => setHeroImageSrc(DEFAULT_LMS_THUMBNAIL)}
//             sx={{
//               width: "100%",
//               borderRadius: 3,
//               overflow: "hidden",
//               height: { xs: 220, md: 320 },
//               objectFit: "cover",
//               objectPosition: "center",
//               bgcolor: "action.hover",
//             }}
//           />

//           <Stack
//             direction={{ xs: "column", md: "row" }}
//             justifyContent="space-between"
//             alignItems={{ xs: "flex-start", md: "flex-start" }}
//             spacing={2}
//           >
//             {/* LEFT CONTENT */}
//             <Stack spacing={1.2} sx={{ flex: 1, minWidth: 0 }}>
//               <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
//                 <Chip label={course.level || t`All Levels`} size="small" />

//                 <Chip label={`${totalLessons} ${t`lessons`}`} size="small" variant="outlined" />

//                 {course.language ? (
//                   <Chip label={course.language} size="small" variant="outlined" />
//                 ) : null}
//               </Stack>

//               <Typography
//                 variant="h4"
//                 fontWeight={700}
//                 sx={{
//                   lineHeight: 1.2,
//                 }}
//               >
//                 {course.title}
//               </Typography>
//             </Stack>

//             {/* RIGHT ACTIONS */}
//             <Stack
//               direction="row"
//               spacing={1.5}
//               sx={{
//                 flexShrink: 0,
//                 alignSelf: { xs: "stretch", md: "flex-start" },
//               }}
//             >
//               {!isEnrolled ? (
//                 <Button
//                   onClick={onEnroll}
//                   variant="contained"
//                   disabled={enrollMutation.isPending}
//                   sx={{
//                     height: 44,
//                     px: 2,
//                     whiteSpace: "nowrap",
//                     textTransform: "none",
//                     minWidth: 140,
//                   }}
//                 >
//                   {enrollMutation.isPending ? t`Enrolling...` : t`Enroll Now`}
//                 </Button>
//               ) : null}

//               <Button
//                 component={Link}
//                 to={`/lms/${course.id}/player`}
//                 variant={isEnrolled ? "contained" : "outlined"}
//                 startIcon={<PlayCircleOutlineOutlinedIcon />}
//                 sx={{
//                   height: 44,
//                   px: 2,
//                   whiteSpace: "nowrap",
//                   textTransform: "none",
//                   minWidth: 170,
//                 }}
//               >
//                 {isEnrolled
//                   ? hasStartedCourse
//                     ? t`Continue Learning`
//                     : t`Start Learning`
//                   : t`Preview Player`}
//               </Button>
//             </Stack>
//           </Stack>

//           {/* DESCRIPTION */}
//           {course.description || course.subtitle ? (
//             <Typography
//               color="text.secondary"
//               sx={{
//                 lineHeight: 1.8,
//                 fontSize: "1rem",
//               }}
//             >
//               {course.description || course.subtitle}
//             </Typography>
//           ) : null}

//           {/* INSTRUCTOR */}
//           {course.instructorName ? (
//             <Typography variant="body1" color="text.secondary">
//               <strong>{t`Instructor`}:</strong> {course.instructorName}
//             </Typography>
//           ) : null}

//           {/* INSTRUCTOR DESCRIPTION */}
//           {course.instructorDescription ? (
//             <Typography
//               variant="body2"
//               color="text.secondary"
//               sx={{
//                 lineHeight: 1.7,
//               }}
//             >
//               <strong>{t`Instructor Description`}:</strong> {course.instructorDescription}
//             </Typography>
//           ) : null}

//           {/* GUEST INSTRUCTORS */}
//           {guestInstructorRows.length > 0 ? (
//             <Stack spacing={1}>
//               <Typography variant="body1" fontWeight={600}>
//                 {t`Guest Instructors`}
//               </Typography>

//               {guestInstructorRows.map((row, index) => (
//                 <Typography
//                   key={`${row.name}-${index}`}
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{
//                     lineHeight: 1.7,
//                   }}
//                 >
//                   <strong>{row.name}</strong>

//                   {row.description ? ` — ${row.description}` : ""}
//                 </Typography>
//               ))}
//             </Stack>
//           ) : null}

//           <Divider />
//           <Tabs
//             value={activeTab}
//             onChange={(_, value: "curriculum" | "chat") => setActiveTab(value)}
//             aria-label="Course tabs"
//           >
//             <Tab value="curriculum" label={t`Course Curriculum`} />
//             <Tab value="chat" label={t`Chat / Community Discussion`} />
//           </Tabs>

//           {activeTab === "curriculum" ? (
//             <Stack spacing={1}>
//               <Typography variant="h6" fontWeight={700}>{t`Course Curriculum`}</Typography>

//               {course.chapters.map((chapter) => {
//                 const state = chapterState[chapter.id];
//                 const quizResult = quizResultsByChapter[chapter.id];
//                 const quizCompleted =
//                   String(quizResult?.status || "").toLowerCase() === "completed";
//                 const hasResources =
//                   chapter.resourcesEnabled &&
//                   (chapter.resources || []).some((item) => String(item.value || "").trim());
//                 const hasQuiz = Boolean(chapter.quizEnabled && chapter.quizId);
//                 const completedLessons = chapter.lessons.filter((lesson) =>
//                   completedLessonIds.has(String(lesson.id)),
//                 );
//                 const allLessonsCompleted = completedLessons.length === chapter.lessons.length;

//                 return (
//                   <Card
//                     key={chapter.id}
//                     variant="outlined"
//                     sx={{
//                       borderRadius: 2,
//                       borderColor: state?.completed ? "success.light" : "divider",
//                       transition: "border-color 0.2s",
//                     }}
//                   >
//                     <CardContent sx={{ pb: "16px !important" }}>
//                       {/* Chapter header row */}
//                       <Stack
//                         direction={{ xs: "column", sm: "row" }}
//                         justifyContent="space-between"
//                         alignItems={{ xs: "flex-start", sm: "center" }}
//                         spacing={1.5}
//                         mb={1.5}
//                       >
//                         {/* Title + meta */}
//                         <Stack spacing={0.3} sx={{ flex: 1, minWidth: 0 }}>
//                           <Stack direction="row" alignItems="center" spacing={1}>
//                             {state?.completed ? (
//                               <CheckCircleOutlineIcon
//                                 fontSize="small"
//                                 sx={{ color: "success.main", flexShrink: 0 }}
//                               />
//                             ) : null}
//                             <Typography fontWeight={700} noWrap={false}>
//                               {chapter.title}
//                             </Typography>
//                           </Stack>
//                           <Stack direction="row" spacing={1} alignItems="center">
//                             <Typography variant="caption" color="text.secondary">
//                               {chapter.lessons.length} {t`lessons`}
//                             </Typography>
//                             {completedLessons.length > 0 ? (
//                               <Chip
//                                 size="small"
//                                 label={`${completedLessons.length}/${chapter.lessons.length} ${t`done`}`}
//                                 color={allLessonsCompleted ? "success" : "default"}
//                                 variant={allLessonsCompleted ? "filled" : "outlined"}
//                                 sx={{ height: 20, fontSize: "0.7rem" }}
//                               />
//                             ) : null}
//                           </Stack>
//                         </Stack>

//                         {/* Action buttons */}
//                         {hasResources || hasQuiz ? (
//                           <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
//                             {hasResources ? (
//                               <Button
//                                 size="small"
//                                 variant={state?.quizUnlocked ? "outlined" : "text"}
//                                 color="primary"
//                                 disabled={!state?.quizUnlocked}
//                                 startIcon={
//                                   state?.quizUnlocked ? (
//                                     <FolderOpenOutlinedIcon fontSize="small" />
//                                   ) : (
//                                     <LockOutlinedIcon fontSize="small" />
//                                   )
//                                 }
//                                 onClick={() => openChapterResources(chapter.id)}
//                                 sx={{
//                                   textTransform: "none",
//                                   borderRadius: 2,
//                                   fontWeight: 500,
//                                   fontSize: "0.8rem",
//                                   px: 1.5,
//                                   opacity: state?.quizUnlocked ? 1 : 0.55,
//                                   whiteSpace: "nowrap",
//                                 }}
//                               >
//                                 {state?.quizUnlocked
//                                   ? chapter.resourcesTitle || t`Resources`
//                                   : t`Resources`}
//                               </Button>
//                             ) : null}

//                             {hasQuiz ? (
//                               <Stack direction="row" spacing={0.75} alignItems="center">
//                                 <Button
//                                   size="small"
//                                   variant={
//                                     quizCompleted
//                                       ? "outlined"
//                                       : state?.quizUnlocked
//                                         ? "contained"
//                                         : "text"
//                                   }
//                                   color={quizCompleted ? "success" : "primary"}
//                                   disabled={!state?.quizUnlocked}
//                                   startIcon={
//                                     quizCompleted ? (
//                                       <CheckCircleOutlineIcon fontSize="small" />
//                                     ) : state?.quizUnlocked ? (
//                                       <QuizOutlinedIcon fontSize="small" />
//                                     ) : (
//                                       <LockOutlinedIcon fontSize="small" />
//                                     )
//                                   }
//                                   onClick={() => openChapterQuiz(chapter.id, chapter.quizId || "")}
//                                   sx={{
//                                     textTransform: "none",
//                                     borderRadius: 2,
//                                     fontWeight: 500,
//                                     fontSize: "0.8rem",
//                                     px: 1.5,
//                                     opacity: state?.quizUnlocked ? 1 : 0.55,
//                                     whiteSpace: "nowrap",
//                                   }}
//                                 >
//                                   {quizCompleted
//                                     ? `${t`Quiz`}: ${quizResult.label}`
//                                     : state?.quizUnlocked
//                                       ? chapter.quizTitle || t`Take Quiz`
//                                       : t`Quiz`}
//                                 </Button>
//                               </Stack>
//                             ) : null}
//                           </Stack>
//                         ) : null}
//                       </Stack>

//                       {/* Completed lessons list */}
//                       <Divider sx={{ mb: 1 }} />
//                       <Stack spacing={0.4}>
//                         {completedLessons.length > 0 ? (
//                           completedLessons.map((lesson) => (
//                             <Stack
//                               key={lesson.id}
//                               direction="row"
//                               spacing={0.75}
//                               alignItems="center"
//                             >
//                               <CheckCircleOutlineIcon
//                                 sx={{ fontSize: 14, color: "success.main", flexShrink: 0 }}
//                               />
//                               <Typography variant="body2" color="text.secondary">
//                                 {lesson.title}
//                               </Typography>
//                             </Stack>
//                           ))
//                         ) : (
//                           <Typography variant="body2" color="text.disabled">
//                             {t`No completed lessons yet.`}
//                           </Typography>
//                         )}
//                       </Stack>
//                     </CardContent>
//                   </Card>
//                 );
//               })}
//               {course.finalQuizEnabled && course.finalQuizId ? (
//                 <Card
//                   variant="outlined"
//                   sx={{
//                     borderRadius: 2,
//                     borderColor:
//                       String(
//                         quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
//                       ).toLowerCase() === "completed"
//                         ? "success.light"
//                         : "divider",
//                     transition: "border-color 0.2s",
//                   }}
//                 >
//                   <CardContent sx={{ pb: "16px !important" }}>
//                     {/* Final quiz header row */}
//                     <Stack
//                       direction={{ xs: "column", sm: "row" }}
//                       justifyContent="space-between"
//                       alignItems={{ xs: "flex-start", sm: "center" }}
//                       spacing={1.5}
//                       mb={
//                         String(
//                           quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
//                         ).toLowerCase() === "completed"
//                           ? 1.5
//                           : 0
//                       }
//                     >
//                       {/* Title + status */}
//                       <Stack spacing={0.3} sx={{ flex: 1, minWidth: 0 }}>
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                           {String(
//                             quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
//                           ).toLowerCase() === "completed" ? (
//                             <WorkspacePremiumOutlinedIcon
//                               fontSize="small"
//                               sx={{ color: "success.main", flexShrink: 0 }}
//                             />
//                           ) : null}
//                           <Typography fontWeight={700} noWrap={false}>
//                             {course.finalQuizTitle || t`Final Quiz`}
//                           </Typography>
//                         </Stack>
//                         {!allChaptersCompleted ? (
//                           <Typography variant="caption" color="text.secondary">
//                             {t`Complete all chapters to unlock`}
//                           </Typography>
//                         ) : null}
//                       </Stack>

//                       {/* Action buttons */}
//                       <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
//                         {String(
//                           quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
//                         ).toLowerCase() === "completed" ? (
//                           <Button
//                             size="small"
//                             variant="outlined"
//                             color="primary"
//                             startIcon={<RateReviewOutlinedIcon fontSize="small" />}
//                             onClick={() => openFeedbackDialog(feedbackStatus === "submitted")}
//                             sx={{
//                               textTransform: "none",
//                               borderRadius: 2,
//                               fontWeight: 500,
//                               fontSize: "0.8rem",
//                               px: 1.5,
//                               whiteSpace: "nowrap",
//                             }}
//                           >
//                             {feedbackStatus === "submitted" ? t`View Feedback` : t`Give Feedback`}
//                           </Button>
//                         ) : null}

//                         <Button
//                           size="small"
//                           variant={
//                             String(
//                               quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
//                             ).toLowerCase() === "completed"
//                               ? "outlined"
//                               : allChaptersCompleted
//                                 ? "contained"
//                                 : "text"
//                           }
//                           color={
//                             String(
//                               quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
//                             ).toLowerCase() === "completed"
//                               ? "success"
//                               : "primary"
//                           }
//                           disabled={!allChaptersCompleted}
//                           startIcon={
//                             String(
//                               quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
//                             ).toLowerCase() === "completed" ? (
//                               <CheckCircleOutlineIcon fontSize="small" />
//                             ) : allChaptersCompleted ? (
//                               <QuizOutlinedIcon fontSize="small" />
//                             ) : (
//                               <LockOutlinedIcon fontSize="small" />
//                             )
//                           }
//                           onClick={() =>
//                             openChapterQuiz(FINAL_QUIZ_CHAPTER_ID, course.finalQuizId || "")
//                           }
//                           sx={{
//                             textTransform: "none",
//                             borderRadius: 2,
//                             fontWeight: 500,
//                             fontSize: "0.8rem",
//                             px: 1.5,
//                             opacity: allChaptersCompleted ? 1 : 0.55,
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {String(
//                             quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
//                           ).toLowerCase() === "completed"
//                             ? `${t`Final Quiz`}: ${quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID].label}`
//                             : allChaptersCompleted
//                               ? t`Start Final Quiz`
//                               : t`Final Quiz`}
//                         </Button>
//                       </Stack>
//                     </Stack>

//                     {/* Feedback status section (only when completed) */}
//                     {String(
//                       quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
//                     ).toLowerCase() === "completed" ? (
//                       <>
//                         <Divider sx={{ mb: 1 }} />
//                         <Stack spacing={0.4}>
//                           <Stack direction="row" spacing={0.75} alignItems="center">
//                             <RateReviewOutlinedIcon
//                               sx={{ fontSize: 14, color: "text.secondary", flexShrink: 0 }}
//                             />
//                             <Typography variant="body2" color="text.secondary">
//                               {t`Feedback`}:{" "}
//                               <strong>
//                                 {feedbackStatus === "submitted"
//                                   ? t`Submitted`
//                                   : feedbackStatus === "skipped"
//                                     ? t`Skipped`
//                                     : t`Pending`}
//                               </strong>
//                             </Typography>
//                           </Stack>
//                           {feedbackStatus === "submitted" ? (
//                             <Typography variant="body2" color="text.secondary" sx={{ pl: 2.5 }}>
//                               {t`Rating`}: {Number(feedbackRating ?? 0)}/5 ⭐
//                             </Typography>
//                           ) : null}
//                         </Stack>
//                       </>
//                     ) : null}
//                   </CardContent>
//                 </Card>
//               ) : null}
//             </Stack>
//           ) : (
//             <Stack spacing={2}>
//               <Typography variant="h6" fontWeight={700}>{t`Community Discussion`}</Typography>
//               {!isEnrolled ? (
//                 <Card variant="outlined" sx={{ borderRadius: 2 }}>
//                   <CardContent>
//                     <Typography color="text.secondary">
//                       {t`Enroll in this course to join the discussion.`}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               ) : (
//                 <>
//                   <Card variant="outlined" sx={{ borderRadius: 2 }}>
//                     <CardContent>
//                       <Box sx={{ maxHeight: 420, overflowY: "auto" }}>
//                         {chatLoading ? (
//                           <Stack alignItems="center" py={3}>
//                             <CircularProgress size={24} />
//                           </Stack>
//                         ) : chatMessages.length === 0 ? (
//                           <Typography color="text.secondary">{t`No messages yet. Start the discussion.`}</Typography>
//                         ) : (
//                           <Stack spacing={1.5}>
//                             {chatMessages.map((row) => {
//                               const messageStudentId = String(row.studentId || "")
//                                 .trim()
//                                 .toLowerCase();
//                               const messageEmail = String(row.email || "")
//                                 .trim()
//                                 .toLowerCase();
//                               const senderName = String(
//                                 row.studentName || row.studentId || "",
//                               ).trim();
//                               const senderRole = extractRoleLabel((row as any)?.role);
//                               const senderLabel = formatNameWithRole(senderName, senderRole);
//                               const isCurrentUser =
//                                 (messageStudentId &&
//                                   currentStudentIdentifiers.includes(messageStudentId)) ||
//                                 (messageEmail && currentStudentIdentifiers.includes(messageEmail));
//                               return (
//                                 <Stack
//                                   key={row.id}
//                                   spacing={0.4}
//                                   alignItems={isCurrentUser ? "flex-end" : "flex-start"}
//                                 >
//                                   <Typography variant="caption" color="text.secondary">
//                                     {isCurrentUser ? currentStudentName || t`You` : senderLabel}
//                                   </Typography>
//                                   <Box
//                                     sx={{
//                                       borderRadius: 2,
//                                       px: 1.5,
//                                       py: 1,
//                                       maxWidth: "85%",
//                                       bgcolor: isCurrentUser ? "primary.main" : "action.hover",
//                                       color: isCurrentUser
//                                         ? "primary.contrastText"
//                                         : "text.primary",
//                                     }}
//                                   >
//                                     <Typography variant="body2">{row.message}</Typography>
//                                   </Box>
//                                   <Typography variant="caption" color="text.secondary">
//                                     {row.createdAt ? new Date(row.createdAt).toLocaleString() : ""}
//                                   </Typography>
//                                 </Stack>
//                               );
//                             })}
//                           </Stack>
//                         )}
//                       </Box>
//                     </CardContent>
//                   </Card>
//                   <Card variant="outlined" sx={{ borderRadius: 2 }}>
//                     <CardContent>
//                       <Stack
//                         direction={{ xs: "column", sm: "row" }}
//                         spacing={1}
//                         alignItems="center"
//                       >
//                         <TextField
//                           fullWidth
//                           multiline
//                           minRows={1}
//                           maxRows={4}
//                           value={chatText}
//                           onChange={(event) => setChatText(event.target.value)}
//                           placeholder={t`Type your message for this course community`}
//                           variant="outlined"
//                           sx={{
//                             "& textarea": {
//                               outline: "none !important",
//                               boxShadow: "none !important",
//                             },
//                           }}
//                         />
//                         <Button
//                           variant="contained"
//                           disabled={chatSubmitting || !chatText.trim()}
//                           onClick={submitChatMessage}
//                           sx={{
//                             height: 36,
//                             minHeight: 36,
//                             borderRadius: 2,
//                             textTransform: "none",
//                             px: 3,
//                             fontWeight: 500,
//                           }}
//                         >
//                           {chatSubmitting ? t`Sending...` : t`Send`}
//                         </Button>
//                       </Stack>
//                     </CardContent>
//                   </Card>
//                 </>
//               )}
//             </Stack>
//           )}
//         </Stack>
//       </Container>

//       <Dialog
//         open={quizDialogOpen}
//         onClose={() => setQuizDialogOpen(false)}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle>{activeQuiz?.title || t`Chapter Quiz`}</DialogTitle>
//         <DialogContent>
//           <Stack spacing={2} sx={{ mt: 1 }}>
//             {(activeQuiz?.questions || []).map((question: any, index: number) => (
//               <Card key={question.id} variant="outlined" sx={{ p: 1 }}>
//                 <Typography fontWeight={600} mb={1}>
//                   {index + 1}. {question.question}
//                 </Typography>
//                 <TextField
//                   select
//                   fullWidth
//                   label={t`Select Answer`}
//                   value={quizAnswers[question.id] ?? ""}
//                   disabled={activeQuizCompleted}
//                   onChange={(event) =>
//                     setQuizAnswers((prev) => ({
//                       ...prev,
//                       [question.id]: Number(event.target.value),
//                     }))
//                   }
//                 >
//                   {question.options.map((option: string, optionIndex: number) => (
//                     <MenuItem key={`${question.id}-${optionIndex}`} value={optionIndex}>
//                       {option}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//               </Card>
//             ))}
//           </Stack>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setQuizDialogOpen(false)}>{t`Cancel`}</Button>
//           {!activeQuizCompleted ? (
//             <Button onClick={submitQuiz} variant="contained" disabled={submittingQuiz}>
//               {submittingQuiz ? t`Submitting...` : t`Submit Quiz`}
//             </Button>
//           ) : (
//             <Stack direction="row" spacing={1}>
//               <Button variant="contained" disabled>
//                 {t`Quiz Completed`}
//               </Button>
//               {nextLessonIdForActiveQuizChapter ? (
//                 <Button
//                   variant="outlined"
//                   component={Link}
//                   to={`/lms/${course.id}/player?lessonId=${encodeURIComponent(nextLessonIdForActiveQuizChapter)}`}
//                   onClick={() => setQuizDialogOpen(false)}
//                 >
//                   {t`Next`}
//                 </Button>
//               ) : null}
//             </Stack>
//           )}
//         </DialogActions>
//       </Dialog>

//       <Dialog
//         open={resourcesDialogOpen}
//         onClose={() => setResourcesDialogOpen(false)}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle>{activeResourcesTitle || t`Chapter Resources`}</DialogTitle>
//         <DialogContent>
//           <Stack spacing={1.5} sx={{ mt: 1 }}>
//             {activeResources.map((resource) => (
//               <Card key={resource.id} variant="outlined" sx={{ borderRadius: 2 }}>
//                 <CardContent>
//                   <Stack spacing={1}>
//                     <Typography fontWeight={700}>
//                       {resource.title ||
//                         (resource.type === "url"
//                           ? t`Resource Link`
//                           : resource.type === "file"
//                             ? t`Resource File`
//                             : t`Resource Note`)}
//                     </Typography>
//                     {resource.type === "file" ||
//                     (resource.type === "text" &&
//                       /^https?:\/\//i.test(String(resource.value || "").trim())) ? (
//                       <Stack spacing={1}>
//                         {String(resource.value || "")
//                           .split("\n")
//                           .map((entry) => entry.trim())
//                           .filter(Boolean)
//                           .map((fileUrl, index) => (
//                             <Button
//                               key={`${resource.id}-file-${index}`}
//                               component="a"
//                               href={mapResourceDownloadUrl(fileUrl)}
//                               download
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               variant="outlined"
//                               sx={{ alignSelf: "flex-start" }}
//                             >
//                               {t`Download file`} {index + 1}
//                             </Button>
//                           ))}
//                       </Stack>
//                     ) : resource.type === "url" ? (
//                       <Button
//                         component="a"
//                         href={resource.value}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         variant="outlined"
//                         sx={{ alignSelf: "flex-start" }}
//                       >
//                         {resource.value}
//                       </Button>
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         {resource.value}
//                       </Typography>
//                     )}
//                   </Stack>
//                 </CardContent>
//               </Card>
//             ))}
//             {activeResources.length === 0 ? (
//               <Typography color="text.secondary">{t`No resources available.`}</Typography>
//             ) : null}
//           </Stack>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setResourcesDialogOpen(false)}>{t`Close`}</Button>
//           {hasQuizForActiveResourcesChapter ? (
//             <Button
//               variant="contained"
//               onClick={async () => {
//                 setResourcesDialogOpen(false);
//                 await openChapterQuiz(
//                   String(activeResourcesChapter?.id || activeResourcesChapterId),
//                   String(activeResourcesChapter?.quizId || ""),
//                 );
//               }}
//             >
//               {t`Next`}
//             </Button>
//           ) : nextLessonIdForActiveResourcesChapter ? (
//             <Button
//               variant="contained"
//               component={Link}
//               to={`/lms/${course.id}/player?lessonId=${encodeURIComponent(nextLessonIdForActiveResourcesChapter)}`}
//               onClick={() => setResourcesDialogOpen(false)}
//             >
//               {t`Next`}
//             </Button>
//           ) : null}
//         </DialogActions>
//       </Dialog>

//       <Dialog
//         open={feedbackDialogOpen}
//         onClose={() => setFeedbackDialogOpen(false)}
//         fullWidth
//         maxWidth="sm"
//       >
//         <DialogTitle>{t`Rate this course`}</DialogTitle>
//         <DialogContent>
//           <Stack spacing={2} sx={{ mt: 1 }}>
//             <Stack spacing={0.5}>
//               <Typography variant="body2">{t`Rating`}</Typography>
//               <Rating
//                 value={feedbackRating}
//                 onChange={(_, value) => setFeedbackRating(value)}
//                 max={5}
//                 readOnly={feedbackReadOnly}
//               />
//             </Stack>
//             <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
//               {FEEDBACK_SUGGESTIONS.map((item) => (
//                 <Chip
//                   key={item}
//                   label={item}
//                   clickable
//                   disabled={feedbackReadOnly}
//                   color={feedbackSuggestions.includes(item) ? "primary" : "default"}
//                   variant={feedbackSuggestions.includes(item) ? "filled" : "outlined"}
//                   onClick={() => toggleFeedbackSuggestion(item)}
//                 />
//               ))}
//             </Stack>
//             <TextField
//               multiline
//               minRows={4}
//               label={t`Feedback`}
//               value={feedbackText}
//               disabled={feedbackReadOnly}
//               onChange={(event) => setFeedbackText(event.target.value)}
//               placeholder={t`Share your feedback or suggestions`}
//               variant="outlined"
//               sx={{
//                 "& textarea": {
//                   outline: "none !important",
//                   boxShadow: "none !important",
//                 },
//               }}
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions>
//           {feedbackReadOnly ? (
//             <Button onClick={() => setFeedbackDialogOpen(false)}>{t`Close`}</Button>
//           ) : (
//             <>
//               <Button onClick={skipCourseFeedback} disabled={feedbackSubmitting}>{t`Skip`}</Button>
//               <Button
//                 variant="contained"
//                 onClick={submitCourseFeedback}
//                 disabled={feedbackSubmitting || Number(feedbackRating ?? 0) < 1}
//               >
//                 {feedbackSubmitting ? t`Submitting...` : t`Submit Feedback`}
//               </Button>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default LmsCourseDetailsPage;


//updated version with certificates ...


import { t } from "@lingui/macro";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  MenuItem,
  Rating,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  fetchLmsCourseChatMessages,
  sendLmsCourseChatMessage,
  fetchStudentLmsCourseFeedback,
  fetchStudentLmsQuizResults,
  fetchLmsQuizById,
  submitLmsCourseFeedback,
  submitLmsChapterQuiz,
  submitLmsFinalQuiz,
  useEnrollLmsCourse,
  useLmsCourseDetails,
} from "@/client/services/lms";
import { useUser } from "@/client/services/user";
import {
  fetchMyCertificates,
  downloadMyCertificate,
  type StudentCertificate,
} from "@/client/services/certificates/certificates";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";

const FINAL_QUIZ_CHAPTER_ID = "__final__";
const DEFAULT_LMS_THUMBNAIL = "/LMS.png";
const FEEDBACK_SUGGESTIONS = [
  "Content quality",
  "Instructor clarity",
  "Quiz quality",
  "Platform experience",
  "Need more examples",
];

const mapResourceDownloadUrl = (rawUrl: string) => {
  const value = String(rawUrl || "").trim();
  if (!value) return value;
  if (value.startsWith("/exam/api/lms/resources/")) {
    return value.replace("/exam/api/lms", "/api/integration/external-service/lms");
  }
  if (value.startsWith("/integration/external-service/lms/resources/")) {
    return `/api${value}`;
  }
  return value;
};

type QuizResultView = {
  label: string;
  status: string;
  answersMap: Record<string, number>;
};

const toQuizLabel = (percentage: unknown) => {
  const parsed = Number(percentage);
  return Number.isFinite(parsed) ? `${parsed}%` : "Completed";
};
const formatNameWithRole = (name: string, role?: string) => {
  const safeName = String(name || "").trim();
  const safeRole = String(role || "")
    .trim()
    .toLowerCase();
  if (!safeName) return "";
  if (!safeRole) return safeName;
  if (safeName.includes("(") && safeName.includes(")")) return safeName;
  return `${safeName}(${safeRole})`;
};
const extractRoleLabel = (roleValue: unknown) => {
  if (!roleValue) return "";
  if (typeof roleValue === "string") return roleValue.trim();
  if (typeof roleValue === "object") {
    const roleObject = roleValue as Record<string, unknown>;
    const candidate =
      roleObject.name || roleObject.role || roleObject.title || roleObject.label || roleObject.code;
    return typeof candidate === "string" ? candidate.trim() : "";
  }
  return "";
};

const LmsCourseDetailsPage = () => {
  const { courseId = "" } = useParams();
  const navigate = useNavigate();
  const { data: course, isLoading, refetch: refetchCourse } = useLmsCourseDetails(courseId);
  const { user } = useUser();
  const enrollMutation = useEnrollLmsCourse();
  const [quizResultsByChapter, setQuizResultsByChapter] = useState<Record<string, QuizResultView>>(
    {},
  );
  const [quizDialogOpen, setQuizDialogOpen] = useState(false);
  const [activeQuizChapterId, setActiveQuizChapterId] = useState("");
  const [activeQuiz, setActiveQuiz] = useState<any>(null);
  const [resourcesDialogOpen, setResourcesDialogOpen] = useState(false);
  const [activeResourcesChapterId, setActiveResourcesChapterId] = useState("");
  const [activeResourcesTitle, setActiveResourcesTitle] = useState("");
  const [activeResources, setActiveResources] = useState<
    Array<{
      id: string;
      type: "url" | "text" | "file";
      title?: string;
      value: string;
    }>
  >([]);
  const [quizAnswers, setQuizAnswers] = useState<Record<string, number>>({});
  const [submittingQuiz, setSubmittingQuiz] = useState(false);
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
  const [feedbackRating, setFeedbackRating] = useState<number | null>(0);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackSuggestions, setFeedbackSuggestions] = useState<string[]>([]);
  const [feedbackSubmitting, setFeedbackSubmitting] = useState(false);
  const [feedbackStatus, setFeedbackStatus] = useState<"submitted" | "skipped" | null>(null);
  const [feedbackReadOnly, setFeedbackReadOnly] = useState(false);
  const [activeTab, setActiveTab] = useState<"curriculum" | "chat">("curriculum");
  const [chatMessages, setChatMessages] = useState<Array<any>>([]);
  const [chatLoading, setChatLoading] = useState(false);
  const [chatSubmitting, setChatSubmitting] = useState(false);
  const [chatText, setChatText] = useState("");
  const [isEnrolledLocal, setIsEnrolledLocal] = useState(false);
  const [heroImageSrc, setHeroImageSrc] = useState(DEFAULT_LMS_THUMBNAIL);
  const isEnrolled = Boolean(course?.enrolled || isEnrolledLocal);
  const currentStudentIdentifiers = useMemo(
    () =>
      Array.from(
        new Set(
          [(user as any)?.rollNo, (user as any)?.studentId, user?.id, user?.email]
            .map((value) =>
              String(value || "")
                .trim()
                .toLowerCase(),
            )
            .filter(Boolean),
        ),
      ),
    [user],
  );
  const currentStudentId = currentStudentIdentifiers[0] || "";
  const currentStudentName = String(
    (user as any)?.name ||
      `${(user as any)?.first_name || ""} ${(user as any)?.last_name || ""}`.trim() ||
      "",
  ).trim();

  const totalLessons = useMemo(
    () =>
      course?.chapters.reduce((accumulator, chapter) => accumulator + chapter.lessons.length, 0) ??
      0,
    [course?.chapters],
  );
  const completedLessonIds = useMemo(
    () => new Set((course?.completedLessonIds || []).map((id) => String(id))),
    [course?.completedLessonIds],
  );
  const chapterState = useMemo(() => {
    const output: Record<string, { unlocked: boolean; completed: boolean; quizUnlocked: boolean }> =
      {};
    let allPreviousCompleted = true;
    (course?.chapters || []).forEach((chapter, chapterIndex) => {
      const lessonsCompleted = (chapter.lessons || []).every((lesson) =>
        completedLessonIds.has(String(lesson.id)),
      );
      const quizRequired = Boolean(chapter.quizEnabled && chapter.quizId);
      const quizCompleted =
        String(quizResultsByChapter[chapter.id]?.status || "").toLowerCase() === "completed";
      const completed = lessonsCompleted && (!quizRequired || quizCompleted);
      const unlocked = chapterIndex === 0 ? true : allPreviousCompleted;
      output[chapter.id] = {
        unlocked,
        completed,
        quizUnlocked: unlocked && lessonsCompleted,
      };
      allPreviousCompleted = allPreviousCompleted && completed;
    });
    return output;
  }, [completedLessonIds, course?.chapters, quizResultsByChapter]);

  const [matchedCertificate, setMatchedCertificate] = useState<StudentCertificate | null>(null);
const [downloadingCertificate, setDownloadingCertificate] = useState(false);
useEffect(() => {
  const run = async () => {
    if (!courseId || !user?.id || !course?.title) return;
    try {
      const certs = await fetchMyCertificates();
      const courseTitle = course.title.trim().toLowerCase();
      const userEmail = String(user?.email || "").trim().toLowerCase();
      const userRollNo = String(
        (user as any)?.rollNo || (user as any)?.studentId || "",
      )
        .trim()
        .toLowerCase();

      const matched = certs.find((cert) => {
        const certCourse = String(cert.courseOrEventName || "")
          .trim()
          .toLowerCase();
        const certEmail = String(cert.metadata?.email || "")
          .trim()
          .toLowerCase();
        const certRoll = String(cert.metadata?.rollNumber || "")
          .trim()
          .toLowerCase();

        const courseMatch = certCourse === courseTitle;
        const identityMatch =
          (userEmail && certEmail && userEmail === certEmail) ||
          (userRollNo && certRoll && userRollNo === certRoll);

        return courseMatch && identityMatch;
      });

      setMatchedCertificate(matched ?? null);
    } catch {
      setMatchedCertificate(null);
    }
  };
  run();
}, [courseId, user?.id, user?.email, course?.title]);

const downloadCourseCertificate = async () => {
  if (!matchedCertificate) return;
  setDownloadingCertificate(true);
  try {
    await downloadMyCertificate(
      matchedCertificate.certificateNumber,
      matchedCertificate.originalFileName,
    );
  } finally {
    setDownloadingCertificate(false);
  }
};

  useEffect(() => {
    const preferredHero = String(
      course?.bannerUrl || course?.thumbnailUrl || DEFAULT_LMS_THUMBNAIL,
    ).trim();
    setHeroImageSrc(preferredHero || DEFAULT_LMS_THUMBNAIL);
  }, [course?.bannerUrl, course?.thumbnailUrl]);

  const allChaptersCompleted = useMemo(
    () => Object.values(chapterState).every((chapter) => chapter.completed),
    [chapterState],
  );
  const nextLessonByChapterId = useMemo(() => {
    const map = new Map<string, string>();
    const chapters = course?.chapters || [];
    chapters.forEach((chapter, chapterIndex) => {
      const nextChapter = chapters[chapterIndex + 1];
      const nextLessonId = String(nextChapter?.lessons?.[0]?.id || "").trim();
      if (nextLessonId) {
        map.set(String(chapter.id), nextLessonId);
      }
    });
    return map;
  }, [course?.chapters]);

  useEffect(() => {
    const run = async () => {
      if (!courseId || !user?.email || !user?.id) return;
      try {
        const rows = await fetchStudentLmsQuizResults(courseId);
        const mapped: Record<string, QuizResultView> = {};
        rows.forEach((row) => {
          const rawAnswers = Array.isArray((row.rawResult as any)?.answers)
            ? (row.rawResult as any).answers
            : [];
          const answersMap: Record<string, number> = {};
          rawAnswers.forEach((answer: any) => {
            const qid = String(answer?.questionId || "").trim();
            if (!qid) return;
            answersMap[qid] = Number(answer?.selectedOptionIndex ?? -1);
          });
          mapped[row.chapterId] = {
            label: toQuizLabel(row.percentage),
            status: String(row.status || ""),
            answersMap,
          };
        });
        setQuizResultsByChapter(mapped);
      } catch {
        setQuizResultsByChapter({});
      }
    };
    run();
  }, [courseId, user?.email, user?.id]);

  useEffect(() => {
    const run = async () => {
      if (!courseId || !user?.id) return;
      try {
        const existing = await fetchStudentLmsCourseFeedback(courseId);
        if (!existing) return;
        const nextStatus = existing.status === "skipped" ? "skipped" : "submitted";
        setFeedbackStatus(nextStatus);
        setFeedbackRating(Number(existing.rating ?? 0));
        setFeedbackText(String(existing.feedback || ""));
        setFeedbackSuggestions(Array.isArray(existing.suggestions) ? existing.suggestions : []);
      } catch {
        // Ignore feedback fetch errors on page load.
      }
    };
    run();
  }, [courseId, user?.id]);

  useEffect(() => {
    if (!course?.id || !isEnrolled || activeTab !== "chat" || !currentStudentId) return;
    let active = true;
    const run = async () => {
      try {
        const rows = await fetchLmsCourseChatMessages(course.id, { limit: 120 });
        if (active) setChatMessages(rows);
      } catch {
        if (active) setChatMessages([]);
      } finally {
        if (active) setChatLoading(false);
      }
    };

    setChatLoading(true);
    run();
    const timer = window.setInterval(run, 8000);
    return () => {
      active = false;
      window.clearInterval(timer);
    };
  }, [activeTab, isEnrolled, course?.id, currentStudentId]);

  const openChapterQuiz = async (chapterId: string, quizId: string) => {
    if (!quizId) return;
    const quiz = await fetchLmsQuizById(quizId);
    setActiveQuizChapterId(chapterId);
    setActiveQuiz(quiz);
    const savedAnswers = quizResultsByChapter[chapterId]?.answersMap || {};
    setQuizAnswers(savedAnswers);
    setQuizDialogOpen(true);
  };

  const openChapterResources = (chapterId: string) => {
    const chapter = (course?.chapters || []).find((item) => String(item.id) === String(chapterId));
    if (!chapter || !chapter.resourcesEnabled) return;
    const resources = (chapter.resources || []).filter((item) => String(item.value || "").trim());
    if (resources.length === 0) return;

    setActiveResourcesChapterId(String(chapter.id));
    setActiveResourcesTitle(String(chapter.resourcesTitle || chapter.title || "").trim());
    setActiveResources(resources);
    setResourcesDialogOpen(true);
  };

  const openFeedbackDialog = (readOnly = false) => {
    setFeedbackReadOnly(readOnly);
    setFeedbackDialogOpen(true);
  };

  const submitQuiz = async () => {
    if (!course || !activeQuizChapterId || !activeQuiz) return;
    if (
      String(quizResultsByChapter[activeQuizChapterId]?.status || "").toLowerCase() === "completed"
    ) {
      setQuizDialogOpen(false);
      return;
    }
    const answers = (activeQuiz.questions || []).map((question: any) => ({
      questionId: question.id,
      selectedOptionIndex: Number(quizAnswers[question.id] ?? -1),
    }));
    setSubmittingQuiz(true);
    try {
      if (activeQuizChapterId === FINAL_QUIZ_CHAPTER_ID) {
        await submitLmsFinalQuiz({
          courseId: course.id,
          answers,
        });
      } else {
        await submitLmsChapterQuiz({
          courseId: course.id,
          chapterId: activeQuizChapterId,
          answers,
        });
      }
      const rows = await fetchStudentLmsQuizResults(course.id);
      const mapped: Record<string, QuizResultView> = {};
      rows.forEach((row) => {
        const rawAnswers = Array.isArray((row.rawResult as any)?.answers)
          ? (row.rawResult as any).answers
          : [];
        const answersMap: Record<string, number> = {};
        rawAnswers.forEach((answer: any) => {
          const qid = String(answer?.questionId || "").trim();
          if (!qid) return;
          answersMap[qid] = Number(answer?.selectedOptionIndex ?? -1);
        });
        mapped[row.chapterId] = {
          label: toQuizLabel(row.percentage),
          status: String(row.status || ""),
          answersMap,
        };
      });
      setQuizResultsByChapter(mapped);
      setQuizDialogOpen(false);
      if (activeQuizChapterId === FINAL_QUIZ_CHAPTER_ID && !feedbackStatus) {
        openFeedbackDialog(false);
      }
    } finally {
      setSubmittingQuiz(false);
    }
  };

  if (isLoading) {
    return (
      <Stack alignItems="center" py={8}>
        <CircularProgress />
      </Stack>
    );
  }

  if (!course) {
    return (
      <Container>
        <Typography>{t`Course not found.`}</Typography>
      </Container>
    );
  }

  const onEnroll = async () => {
    await enrollMutation.mutateAsync({ courseId: course.id });
    setIsEnrolledLocal(true);
    await refetchCourse();
  };
  const downloadCertificate = () => {
    const profile = user as any;
    const identifiers = Array.from(
      new Set(
        [profile?.id, profile?.studentId, profile?.rollNo, profile?.email]
          .map((value) => String(value || "").trim())
          .filter(Boolean),
      ),
    );
    const studentName = String(
      profile?.name || `${profile?.first_name || ""} ${profile?.last_name || ""}`.trim() || "",
    ).trim();
    const params = new URLSearchParams();
    if (identifiers[0]) params.set("studentId", identifiers[0]);
    if (identifiers.length > 0) params.set("identifiers", identifiers.join(","));
    if (studentName) params.set("studentName", studentName);
    const url = `/api/integration/external-service/lms/courses/${course.id}/certificate?${params.toString()}`;
    window.open(url, "_blank");
  };
  const activeQuizCompleted =
    String(quizResultsByChapter[activeQuizChapterId]?.status || "").toLowerCase() === "completed";
  const nextLessonIdForActiveQuizChapter = String(
    nextLessonByChapterId.get(String(activeQuizChapterId)) || "",
  ).trim();
  const nextLessonIdForActiveResourcesChapter = String(
    nextLessonByChapterId.get(String(activeResourcesChapterId)) || "",
  ).trim();
  const activeResourcesChapter = (course?.chapters || []).find(
    (chapter) => String(chapter.id) === String(activeResourcesChapterId),
  );
  const hasQuizForActiveResourcesChapter = Boolean(
    activeResourcesChapter?.quizEnabled && String(activeResourcesChapter?.quizId || "").trim(),
  );
  const hasStartedCourse = Number(course.progressPercent ?? 0) > 0 || completedLessonIds.size > 0;
  const guestInstructorRows = (course.guestInstructors || [])
    .map((name, index) => ({
      name: String(name || "").trim(),
      description: String(course.guestInstructorDescriptions?.[index] || "").trim(),
    }))
    .filter((row) => row.name);

  const loadCourseChatMessages = async () => {
    if (!course?.id || !isEnrolled || !currentStudentId) return;
    setChatLoading(true);
    try {
      const rows = await fetchLmsCourseChatMessages(course.id, { limit: 120 });
      setChatMessages(rows);
    } catch {
      setChatMessages([]);
    } finally {
      setChatLoading(false);
    }
  };

  const submitChatMessage = async () => {
    if (!course?.id || !isEnrolled) return;
    const message = chatText.trim();
    if (!message) return;
    setChatSubmitting(true);
    try {
      await sendLmsCourseChatMessage({ courseId: course.id, message });
      setChatText("");
      await loadCourseChatMessages();
    } finally {
      setChatSubmitting(false);
    }
  };

  const toggleFeedbackSuggestion = (value: string) => {
    setFeedbackSuggestions((prev) =>
      prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value],
    );
  };

  const submitCourseFeedback = async () => {
    if (!course) return;
    if (feedbackStatus === "submitted") return;
    const rating = Number(feedbackRating ?? 0);
    if (rating < 1 || rating > 5) return;

    setFeedbackSubmitting(true);
    try {
      await submitLmsCourseFeedback({
        courseId: course.id,
        status: "submitted",
        rating,
        feedback: feedbackText,
        suggestions: feedbackSuggestions,
      });
      setFeedbackStatus("submitted");
      setFeedbackReadOnly(true);
      setFeedbackDialogOpen(false);
    } finally {
      setFeedbackSubmitting(false);
    }
  };

  const skipCourseFeedback = async () => {
    if (!course) return;
    if (feedbackStatus === "submitted") {
      setFeedbackDialogOpen(false);
      return;
    }
    setFeedbackSubmitting(true);
    try {
      await submitLmsCourseFeedback({
        courseId: course.id,
        status: "skipped",
        rating: 0,
        feedback: "",
        suggestions: [],
      });
      setFeedbackStatus("skipped");
      setFeedbackDialogOpen(false);
    } finally {
      setFeedbackSubmitting(false);
    }
  };
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/lms");
  };

  return (
    <Box>
      <Container>
        <Stack spacing={2}>
          <Box>
            <Button
              startIcon={<ArrowBackIcon />}
              size="small"
              onClick={handleGoBack}
              sx={{ textTransform: "none" }}
            >
              {t`Back`}
            </Button>
          </Box>
          <Box
            component="img"
            src={heroImageSrc}
            alt={course.title}
            onError={() => setHeroImageSrc(DEFAULT_LMS_THUMBNAIL)}
            sx={{
              width: "100%",
              borderRadius: 3,
              overflow: "hidden",
              height: { xs: 220, md: 320 },
              objectFit: "cover",
              objectPosition: "center",
              bgcolor: "action.hover",
            }}
          />

          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", md: "flex-start" }}
            spacing={2}
          >
            {/* LEFT CONTENT */}
            <Stack spacing={1.2} sx={{ flex: 1, minWidth: 0 }}>
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                <Chip label={course.level || t`All Levels`} size="small" />

                <Chip label={`${totalLessons} ${t`lessons`}`} size="small" variant="outlined" />

                {course.language ? (
                  <Chip label={course.language} size="small" variant="outlined" />
                ) : null}
              </Stack>

              <Typography
                variant="h4"
                fontWeight={700}
                sx={{
                  lineHeight: 1.2,
                }}
              >
                {course.title}
              </Typography>
            </Stack>

            {/* RIGHT ACTIONS */}
            {/* RIGHT ACTIONS */}
<Stack
  direction="row"
  spacing={1.5}
  sx={{
    flexShrink: 0,
    alignSelf: { xs: "stretch", md: "flex-start" },
  }}
>
  {!isEnrolled ? (
    <Button
      onClick={onEnroll}
      variant="contained"
      disabled={enrollMutation.isPending}
      sx={{ height: 44, px: 2, whiteSpace: "nowrap", textTransform: "none", minWidth: 140 }}
    >
      {enrollMutation.isPending ? t`Enrolling...` : t`Enroll Now`}
    </Button>
  ) : null}

  {/* ↓ NEW: Download Certificate button — only when a matching cert exists */}
  {isEnrolled && matchedCertificate ? (
    <Button
      variant="outlined"
      color="success"
      startIcon={
        downloadingCertificate ? (
          <CircularProgress size={16} />
        ) : (
          <WorkspacePremiumOutlinedIcon />
        )
      }
      disabled={downloadingCertificate}
      onClick={downloadCourseCertificate}
      sx={{
        height: 44,
        px: 2,
        whiteSpace: "nowrap",
        textTransform: "none",
        minWidth: 190,
      }}
    >
      {downloadingCertificate ? t`Downloading...` : t`Download Certificate`}
    </Button>
  ) : null}

  <Button
    component={Link}
    to={`/lms/${course.id}/player`}
    variant={isEnrolled ? "contained" : "outlined"}
    startIcon={<PlayCircleOutlineOutlinedIcon />}
    sx={{ height: 44, px: 2, whiteSpace: "nowrap", textTransform: "none", minWidth: 170 }}
  >
    {isEnrolled
      ? hasStartedCourse
        ? t`Continue Learning`
        : t`Start Learning`
      : t`Preview Player`}
  </Button>
</Stack>
            {/* <Stack
              direction="row"
              spacing={1.5}
              sx={{
                flexShrink: 0,
                alignSelf: { xs: "stretch", md: "flex-start" },
              }}
            >
              {!isEnrolled ? (
                <Button
                  onClick={onEnroll}
                  variant="contained"
                  disabled={enrollMutation.isPending}
                  sx={{
                    height: 44,
                    px: 2,
                    whiteSpace: "nowrap",
                    textTransform: "none",
                    minWidth: 140,
                  }}
                >
                  {enrollMutation.isPending ? t`Enrolling...` : t`Enroll Now`}
                </Button>
              ) : null}

              <Button
                component={Link}
                to={`/lms/${course.id}/player`}
                variant={isEnrolled ? "contained" : "outlined"}
                startIcon={<PlayCircleOutlineOutlinedIcon />}
                sx={{
                  height: 44,
                  px: 2,
                  whiteSpace: "nowrap",
                  textTransform: "none",
                  minWidth: 170,
                }}
              >
                {isEnrolled
                  ? hasStartedCourse
                    ? t`Continue Learning`
                    : t`Start Learning`
                  : t`Preview Player`}
              </Button>
            </Stack> */}
          </Stack>

          {/* DESCRIPTION */}
          {course.description || course.subtitle ? (
            <Typography
              color="text.secondary"
              sx={{
                lineHeight: 1.8,
                fontSize: "1rem",
              }}
            >
              {course.description || course.subtitle}
            </Typography>
          ) : null}

          {/* INSTRUCTOR */}
          {course.instructorName ? (
            <Typography variant="body1" color="text.secondary">
              <strong>{t`Instructor`}:</strong> {course.instructorName}
            </Typography>
          ) : null}

          {/* INSTRUCTOR DESCRIPTION */}
          {course.instructorDescription ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.7,
              }}
            >
              <strong>{t`Instructor Description`}:</strong> {course.instructorDescription}
            </Typography>
          ) : null}

          {/* GUEST INSTRUCTORS */}
          {guestInstructorRows.length > 0 ? (
            <Stack spacing={1}>
              <Typography variant="body1" fontWeight={600}>
                {t`Guest Instructors`}
              </Typography>

              {guestInstructorRows.map((row, index) => (
                <Typography
                  key={`${row.name}-${index}`}
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    lineHeight: 1.7,
                  }}
                >
                  <strong>{row.name}</strong>

                  {row.description ? ` — ${row.description}` : ""}
                </Typography>
              ))}
            </Stack>
          ) : null}

          <Divider />
          <Tabs
            value={activeTab}
            onChange={(_, value: "curriculum" | "chat") => setActiveTab(value)}
            aria-label="Course tabs"
          >
            <Tab value="curriculum" label={t`Course Curriculum`} />
            <Tab value="chat" label={t`Chat / Community Discussion`} />
          </Tabs>

          {activeTab === "curriculum" ? (
            <Stack spacing={1}>
              <Typography variant="h6" fontWeight={700}>{t`Course Curriculum`}</Typography>

              {course.chapters.map((chapter) => {
                const state = chapterState[chapter.id];
                const quizResult = quizResultsByChapter[chapter.id];
                const quizCompleted =
                  String(quizResult?.status || "").toLowerCase() === "completed";
                const hasResources =
                  chapter.resourcesEnabled &&
                  (chapter.resources || []).some((item) => String(item.value || "").trim());
                const hasQuiz = Boolean(chapter.quizEnabled && chapter.quizId);
                const completedLessons = chapter.lessons.filter((lesson) =>
                  completedLessonIds.has(String(lesson.id)),
                );
                const allLessonsCompleted = completedLessons.length === chapter.lessons.length;

                return (
                  <Card
                    key={chapter.id}
                    variant="outlined"
                    sx={{
                      borderRadius: 2,
                      borderColor: state?.completed ? "success.light" : "divider",
                      transition: "border-color 0.2s",
                    }}
                  >
                    <CardContent sx={{ pb: "16px !important" }}>
                      {/* Chapter header row */}
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", sm: "center" }}
                        spacing={1.5}
                        mb={1.5}
                      >
                        {/* Title + meta */}
                        <Stack spacing={0.3} sx={{ flex: 1, minWidth: 0 }}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            {state?.completed ? (
                              <CheckCircleOutlineIcon
                                fontSize="small"
                                sx={{ color: "success.main", flexShrink: 0 }}
                              />
                            ) : null}
                            <Typography fontWeight={700} noWrap={false}>
                              {chapter.title}
                            </Typography>
                          </Stack>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography variant="caption" color="text.secondary">
                              {chapter.lessons.length} {t`lessons`}
                            </Typography>
                            {completedLessons.length > 0 ? (
                              <Chip
                                size="small"
                                label={`${completedLessons.length}/${chapter.lessons.length} ${t`done`}`}
                                color={allLessonsCompleted ? "success" : "default"}
                                variant={allLessonsCompleted ? "filled" : "outlined"}
                                sx={{ height: 20, fontSize: "0.7rem" }}
                              />
                            ) : null}
                          </Stack>
                        </Stack>

                        {/* Action buttons */}
                        {hasResources || hasQuiz ? (
                          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                            {hasResources ? (
                              <Button
                                size="small"
                                variant={state?.quizUnlocked ? "outlined" : "text"}
                                color="primary"
                                disabled={!state?.quizUnlocked}
                                startIcon={
                                  state?.quizUnlocked ? (
                                    <FolderOpenOutlinedIcon fontSize="small" />
                                  ) : (
                                    <LockOutlinedIcon fontSize="small" />
                                  )
                                }
                                onClick={() => openChapterResources(chapter.id)}
                                sx={{
                                  textTransform: "none",
                                  borderRadius: 2,
                                  fontWeight: 500,
                                  fontSize: "0.8rem",
                                  px: 1.5,
                                  opacity: state?.quizUnlocked ? 1 : 0.55,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {state?.quizUnlocked
                                  ? chapter.resourcesTitle || t`Resources`
                                  : t`Resources`}
                              </Button>
                            ) : null}

                            {hasQuiz ? (
                              <Stack direction="row" spacing={0.75} alignItems="center">
                                <Button
                                  size="small"
                                  variant={
                                    quizCompleted
                                      ? "outlined"
                                      : state?.quizUnlocked
                                        ? "contained"
                                        : "text"
                                  }
                                  color={quizCompleted ? "success" : "primary"}
                                  disabled={!state?.quizUnlocked}
                                  startIcon={
                                    quizCompleted ? (
                                      <CheckCircleOutlineIcon fontSize="small" />
                                    ) : state?.quizUnlocked ? (
                                      <QuizOutlinedIcon fontSize="small" />
                                    ) : (
                                      <LockOutlinedIcon fontSize="small" />
                                    )
                                  }
                                  onClick={() => openChapterQuiz(chapter.id, chapter.quizId || "")}
                                  sx={{
                                    textTransform: "none",
                                    borderRadius: 2,
                                    fontWeight: 500,
                                    fontSize: "0.8rem",
                                    px: 1.5,
                                    opacity: state?.quizUnlocked ? 1 : 0.55,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {quizCompleted
                                    ? `${t`Quiz`}: ${quizResult.label}`
                                    : state?.quizUnlocked
                                      ? chapter.quizTitle || t`Take Quiz`
                                      : t`Quiz`}
                                </Button>
                              </Stack>
                            ) : null}
                          </Stack>
                        ) : null}
                      </Stack>

                      {/* Completed lessons list */}
                      <Divider sx={{ mb: 1 }} />
                      <Stack spacing={0.4}>
                        {completedLessons.length > 0 ? (
                          completedLessons.map((lesson) => (
                            <Stack
                              key={lesson.id}
                              direction="row"
                              spacing={0.75}
                              alignItems="center"
                            >
                              <CheckCircleOutlineIcon
                                sx={{ fontSize: 14, color: "success.main", flexShrink: 0 }}
                              />
                              <Typography variant="body2" color="text.secondary">
                                {lesson.title}
                              </Typography>
                            </Stack>
                          ))
                        ) : (
                          <Typography variant="body2" color="text.disabled">
                            {t`No completed lessons yet.`}
                          </Typography>
                        )}
                      </Stack>
                    </CardContent>
                  </Card>
                );
              })}
              {course.finalQuizEnabled && course.finalQuizId ? (
                <Card
                  variant="outlined"
                  sx={{
                    borderRadius: 2,
                    borderColor:
                      String(
                        quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
                      ).toLowerCase() === "completed"
                        ? "success.light"
                        : "divider",
                    transition: "border-color 0.2s",
                  }}
                >
                  <CardContent sx={{ pb: "16px !important" }}>
                    {/* Final quiz header row */}
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      justifyContent="space-between"
                      alignItems={{ xs: "flex-start", sm: "center" }}
                      spacing={1.5}
                      mb={
                        String(
                          quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
                        ).toLowerCase() === "completed"
                          ? 1.5
                          : 0
                      }
                    >
                      {/* Title + status */}
                      <Stack spacing={0.3} sx={{ flex: 1, minWidth: 0 }}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          {String(
                            quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
                          ).toLowerCase() === "completed" ? (
                            <WorkspacePremiumOutlinedIcon
                              fontSize="small"
                              sx={{ color: "success.main", flexShrink: 0 }}
                            />
                          ) : null}
                          <Typography fontWeight={700} noWrap={false}>
                            {course.finalQuizTitle || t`Final Quiz`}
                          </Typography>
                        </Stack>
                        {!allChaptersCompleted ? (
                          <Typography variant="caption" color="text.secondary">
                            {t`Complete all chapters to unlock`}
                          </Typography>
                        ) : null}
                      </Stack>

                      {/* Action buttons */}
                      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        {String(
                          quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
                        ).toLowerCase() === "completed" ? (
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            startIcon={<RateReviewOutlinedIcon fontSize="small" />}
                            onClick={() => openFeedbackDialog(feedbackStatus === "submitted")}
                            sx={{
                              textTransform: "none",
                              borderRadius: 2,
                              fontWeight: 500,
                              fontSize: "0.8rem",
                              px: 1.5,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {feedbackStatus === "submitted" ? t`View Feedback` : t`Give Feedback`}
                          </Button>
                        ) : null}

                        <Button
                          size="small"
                          variant={
                            String(
                              quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
                            ).toLowerCase() === "completed"
                              ? "outlined"
                              : allChaptersCompleted
                                ? "contained"
                                : "text"
                          }
                          color={
                            String(
                              quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
                            ).toLowerCase() === "completed"
                              ? "success"
                              : "primary"
                          }
                          disabled={!allChaptersCompleted}
                          startIcon={
                            String(
                              quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
                            ).toLowerCase() === "completed" ? (
                              <CheckCircleOutlineIcon fontSize="small" />
                            ) : allChaptersCompleted ? (
                              <QuizOutlinedIcon fontSize="small" />
                            ) : (
                              <LockOutlinedIcon fontSize="small" />
                            )
                          }
                          onClick={() =>
                            openChapterQuiz(FINAL_QUIZ_CHAPTER_ID, course.finalQuizId || "")
                          }
                          sx={{
                            textTransform: "none",
                            borderRadius: 2,
                            fontWeight: 500,
                            fontSize: "0.8rem",
                            px: 1.5,
                            opacity: allChaptersCompleted ? 1 : 0.55,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {String(
                            quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
                          ).toLowerCase() === "completed"
                            ? `${t`Final Quiz`}: ${quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID].label}`
                            : allChaptersCompleted
                              ? t`Start Final Quiz`
                              : t`Final Quiz`}
                        </Button>
                      </Stack>
                    </Stack>

                    {/* Feedback status section (only when completed) */}
                    {String(
                      quizResultsByChapter[FINAL_QUIZ_CHAPTER_ID]?.status || "",
                    ).toLowerCase() === "completed" ? (
                      <>
                        <Divider sx={{ mb: 1 }} />
                        <Stack spacing={0.4}>
                          <Stack direction="row" spacing={0.75} alignItems="center">
                            <RateReviewOutlinedIcon
                              sx={{ fontSize: 14, color: "text.secondary", flexShrink: 0 }}
                            />
                            <Typography variant="body2" color="text.secondary">
                              {t`Feedback`}:{" "}
                              <strong>
                                {feedbackStatus === "submitted"
                                  ? t`Submitted`
                                  : feedbackStatus === "skipped"
                                    ? t`Skipped`
                                    : t`Pending`}
                              </strong>
                            </Typography>
                          </Stack>
                          {feedbackStatus === "submitted" ? (
                            <Typography variant="body2" color="text.secondary" sx={{ pl: 2.5 }}>
                              {t`Rating`}: {Number(feedbackRating ?? 0)}/5 ⭐
                            </Typography>
                          ) : null}
                        </Stack>
                      </>
                    ) : null}
                  </CardContent>
                </Card>
              ) : null}
            </Stack>
          ) : (
            <Stack spacing={2}>
              <Typography variant="h6" fontWeight={700}>{t`Community Discussion`}</Typography>
              {!isEnrolled ? (
                <Card variant="outlined" sx={{ borderRadius: 2 }}>
                  <CardContent>
                    <Typography color="text.secondary">
                      {t`Enroll in this course to join the discussion.`}
                    </Typography>
                  </CardContent>
                </Card>
              ) : (
                <>
                  <Card variant="outlined" sx={{ borderRadius: 2 }}>
                    <CardContent>
                      <Box sx={{ maxHeight: 420, overflowY: "auto" }}>
                        {chatLoading ? (
                          <Stack alignItems="center" py={3}>
                            <CircularProgress size={24} />
                          </Stack>
                        ) : chatMessages.length === 0 ? (
                          <Typography color="text.secondary">{t`No messages yet. Start the discussion.`}</Typography>
                        ) : (
                          <Stack spacing={1.5}>
                            {chatMessages.map((row) => {
                              const messageStudentId = String(row.studentId || "")
                                .trim()
                                .toLowerCase();
                              const messageEmail = String(row.email || "")
                                .trim()
                                .toLowerCase();
                              const senderName = String(
                                row.studentName || row.studentId || "",
                              ).trim();
                              const senderRole = extractRoleLabel((row as any)?.role);
                              const senderLabel = formatNameWithRole(senderName, senderRole);
                              const isCurrentUser =
                                (messageStudentId &&
                                  currentStudentIdentifiers.includes(messageStudentId)) ||
                                (messageEmail && currentStudentIdentifiers.includes(messageEmail));
                              return (
                                <Stack
                                  key={row.id}
                                  spacing={0.4}
                                  alignItems={isCurrentUser ? "flex-end" : "flex-start"}
                                >
                                  <Typography variant="caption" color="text.secondary">
                                    {isCurrentUser ? currentStudentName || t`You` : senderLabel}
                                  </Typography>
                                  <Box
                                    sx={{
                                      borderRadius: 2,
                                      px: 1.5,
                                      py: 1,
                                      maxWidth: "85%",
                                      bgcolor: isCurrentUser ? "primary.main" : "action.hover",
                                      color: isCurrentUser
                                        ? "primary.contrastText"
                                        : "text.primary",
                                    }}
                                  >
                                    <Typography variant="body2">{row.message}</Typography>
                                  </Box>
                                  <Typography variant="caption" color="text.secondary">
                                    {row.createdAt ? new Date(row.createdAt).toLocaleString() : ""}
                                  </Typography>
                                </Stack>
                              );
                            })}
                          </Stack>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                  <Card variant="outlined" sx={{ borderRadius: 2 }}>
                    <CardContent>
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={1}
                        alignItems="center"
                      >
                        <TextField
                          fullWidth
                          multiline
                          minRows={1}
                          maxRows={4}
                          value={chatText}
                          onChange={(event) => setChatText(event.target.value)}
                          placeholder={t`Type your message for this course community`}
                          variant="outlined"
                          sx={{
                            "& textarea": {
                              outline: "none !important",
                              boxShadow: "none !important",
                            },
                          }}
                        />
                        <Button
                          variant="contained"
                          disabled={chatSubmitting || !chatText.trim()}
                          onClick={submitChatMessage}
                          sx={{
                            height: 36,
                            minHeight: 36,
                            borderRadius: 2,
                            textTransform: "none",
                            px: 3,
                            fontWeight: 500,
                          }}
                        >
                          {chatSubmitting ? t`Sending...` : t`Send`}
                        </Button>
                      </Stack>
                    </CardContent>
                  </Card>
                </>
              )}
            </Stack>
          )}
        </Stack>
      </Container>

      <Dialog
        open={quizDialogOpen}
        onClose={() => setQuizDialogOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{activeQuiz?.title || t`Chapter Quiz`}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            {(activeQuiz?.questions || []).map((question: any, index: number) => (
              <Card key={question.id} variant="outlined" sx={{ p: 1 }}>
                <Typography fontWeight={600} mb={1}>
                  {index + 1}. {question.question}
                </Typography>
                <TextField
                  select
                  fullWidth
                  label={t`Select Answer`}
                  value={quizAnswers[question.id] ?? ""}
                  disabled={activeQuizCompleted}
                  onChange={(event) =>
                    setQuizAnswers((prev) => ({
                      ...prev,
                      [question.id]: Number(event.target.value),
                    }))
                  }
                >
                  {question.options.map((option: string, optionIndex: number) => (
                    <MenuItem key={`${question.id}-${optionIndex}`} value={optionIndex}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Card>
            ))}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setQuizDialogOpen(false)}>{t`Cancel`}</Button>
          {!activeQuizCompleted ? (
            <Button onClick={submitQuiz} variant="contained" disabled={submittingQuiz}>
              {submittingQuiz ? t`Submitting...` : t`Submit Quiz`}
            </Button>
          ) : (
            <Stack direction="row" spacing={1}>
              <Button variant="contained" disabled>
                {t`Quiz Completed`}
              </Button>
              {nextLessonIdForActiveQuizChapter ? (
                <Button
                  variant="outlined"
                  component={Link}
                  to={`/lms/${course.id}/player?lessonId=${encodeURIComponent(nextLessonIdForActiveQuizChapter)}`}
                  onClick={() => setQuizDialogOpen(false)}
                >
                  {t`Next`}
                </Button>
              ) : null}
            </Stack>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={resourcesDialogOpen}
        onClose={() => setResourcesDialogOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{activeResourcesTitle || t`Chapter Resources`}</DialogTitle>
        <DialogContent>
          <Stack spacing={1.5} sx={{ mt: 1 }}>
            {activeResources.map((resource) => (
              <Card key={resource.id} variant="outlined" sx={{ borderRadius: 2 }}>
                <CardContent>
                  <Stack spacing={1}>
                    <Typography fontWeight={700}>
                      {resource.title ||
                        (resource.type === "url"
                          ? t`Resource Link`
                          : resource.type === "file"
                            ? t`Resource File`
                            : t`Resource Note`)}
                    </Typography>
                    {resource.type === "file" ||
                    (resource.type === "text" &&
                      /^https?:\/\//i.test(String(resource.value || "").trim())) ? (
                      <Stack spacing={1}>
                        {String(resource.value || "")
                          .split("\n")
                          .map((entry) => entry.trim())
                          .filter(Boolean)
                          .map((fileUrl, index) => (
                            <Button
                              key={`${resource.id}-file-${index}`}
                              component="a"
                              href={mapResourceDownloadUrl(fileUrl)}
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                              variant="outlined"
                              sx={{ alignSelf: "flex-start" }}
                            >
                              {t`Download file`} {index + 1}
                            </Button>
                          ))}
                      </Stack>
                    ) : resource.type === "url" ? (
                      <Button
                        component="a"
                        href={resource.value}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="outlined"
                        sx={{ alignSelf: "flex-start" }}
                      >
                        {resource.value}
                      </Button>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        {resource.value}
                      </Typography>
                    )}
                  </Stack>
                </CardContent>
              </Card>
            ))}
            {activeResources.length === 0 ? (
              <Typography color="text.secondary">{t`No resources available.`}</Typography>
            ) : null}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setResourcesDialogOpen(false)}>{t`Close`}</Button>
          {hasQuizForActiveResourcesChapter ? (
            <Button
              variant="contained"
              onClick={async () => {
                setResourcesDialogOpen(false);
                await openChapterQuiz(
                  String(activeResourcesChapter?.id || activeResourcesChapterId),
                  String(activeResourcesChapter?.quizId || ""),
                );
              }}
            >
              {t`Next`}
            </Button>
          ) : nextLessonIdForActiveResourcesChapter ? (
            <Button
              variant="contained"
              component={Link}
              to={`/lms/${course.id}/player?lessonId=${encodeURIComponent(nextLessonIdForActiveResourcesChapter)}`}
              onClick={() => setResourcesDialogOpen(false)}
            >
              {t`Next`}
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>

      <Dialog
        open={feedbackDialogOpen}
        onClose={() => setFeedbackDialogOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{t`Rate this course`}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <Stack spacing={0.5}>
              <Typography variant="body2">{t`Rating`}</Typography>
              <Rating
                value={feedbackRating}
                onChange={(_, value) => setFeedbackRating(value)}
                max={5}
                readOnly={feedbackReadOnly}
              />
            </Stack>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              {FEEDBACK_SUGGESTIONS.map((item) => (
                <Chip
                  key={item}
                  label={item}
                  clickable
                  disabled={feedbackReadOnly}
                  color={feedbackSuggestions.includes(item) ? "primary" : "default"}
                  variant={feedbackSuggestions.includes(item) ? "filled" : "outlined"}
                  onClick={() => toggleFeedbackSuggestion(item)}
                />
              ))}
            </Stack>
            <TextField
              multiline
              minRows={4}
              label={t`Feedback`}
              value={feedbackText}
              disabled={feedbackReadOnly}
              onChange={(event) => setFeedbackText(event.target.value)}
              placeholder={t`Share your feedback or suggestions`}
              variant="outlined"
              sx={{
                "& textarea": {
                  outline: "none !important",
                  boxShadow: "none !important",
                },
              }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          {feedbackReadOnly ? (
            <Button onClick={() => setFeedbackDialogOpen(false)}>{t`Close`}</Button>
          ) : (
            <>
              <Button onClick={skipCourseFeedback} disabled={feedbackSubmitting}>{t`Skip`}</Button>
              <Button
                variant="contained"
                onClick={submitCourseFeedback}
                disabled={feedbackSubmitting || Number(feedbackRating ?? 0) < 1}
              >
                {feedbackSubmitting ? t`Submitting...` : t`Submit Feedback`}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LmsCourseDetailsPage;
